export default {"src":"/_next/static/media/sealQuestion_24.cd19cab7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};